import { DestinationListReducerState } from './interface';

export const DESTINATION_LIST_REDUCER_DEFAULT_STATE: DestinationListReducerState = {};
